// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__1xK51","modal__remainbutton":"deleteModal_modal__remainbutton__136Wk","modal__deletebutton":"deleteModal_modal__deletebutton__2um8k"};